import { render, staticRenderFns } from "./InventorySummary.vue?vue&type=template&id=bab0de2c&scoped=true"
import script from "./InventorySummary.vue?vue&type=script&lang=js"
export * from "./InventorySummary.vue?vue&type=script&lang=js"
import style0 from "./InventorySummary.vue?vue&type=style&index=0&id=bab0de2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bab0de2c",
  null
  
)

export default component.exports